import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {InteractionEvent, InteractionService, InteractionSubjectData} from "../../service/interaction.service";
import {CarouselPageEvent} from "primeng/carousel";
import {InteractionStepComponent} from "../interaction-step/interaction-step.component";


@Component({
  selector: 'app-interaction-intro',
  templateUrl: './interaction-intro.component.html',
  styleUrls:['interaction-intro.component.scss']
})
export class InteractionIntroComponent extends InteractionStepComponent implements OnInit, OnDestroy {

  currentCarouselIndex: number = 0; // Default to the first item


  override ngOnInit() {
    super.ngOnInit();

    // always revert to the index 0
    this.currentCarouselIndex = 0;

  }

  override handleEvent(event: InteractionEvent) {
    super.handleEvent(event);

    if (event == "next") {
      if (this.interactionData) {
        if (this.interactionData.type && this.interactionData.type?.infoSteps.length > this.currentCarouselIndex + 1) {
          this.currentCarouselIndex++; // move carousel first
        } else {
          // lets go to the next step
          this.interactionService.nextStep();
        }
      }
    } else if (event == "previous") {
      // previous step not supported
    }

  }

  handleCarouselPageChange(event: CarouselPageEvent) {
    if (event?.page) {
      this.currentCarouselIndex = event.page;
    }
  }


}
